export default __webpack_public_path__ + "static/media/socks.9a6a9225.svg";